import { PREDICTIVE_MODELS } from '@/router/recruiter/predictiveModels';

import { CAMPAIGNS } from './campaigns';
import { COMPETENCY_FRAMEWORK } from './competencyFramework';
import { NETWORK } from './network';
import { PROFILE } from './profile';
import { SOURCING } from './sourcing';
import { TEAM_ANALYSIS } from './teamAnalysis';
import { AMBASSADOR } from './ambassador';

export const RECRUITER_ROUTES = {
  path: '/recruiter',
  name: 'recruiter',
  redirect: { name: 'network' },
  children: [SOURCING, PROFILE, CAMPAIGNS, PREDICTIVE_MODELS, NETWORK, COMPETENCY_FRAMEWORK, TEAM_ANALYSIS, AMBASSADOR],
  meta: {
    permissions: ['recruiter_r']
  }
};
